//
import PermissionModel from '@/models/Permission'

//
import { required } from '@/services/validations'
import headers from './headers'

//
export default props => [
    {
        name: 'name',
        type: 'text-field',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            label: 'Nombre',
            rules: [ required ],
        },
    },
    {
        name: 'role_name',
        type: 'text-field',
        flex: {
            sm6: true,
        },
        props: {
            label: 'Nombre para mostrar',
            rules: [ required ],
        },
    },
    {
        name: 'selected_permissions',
        type: 'table-field',
        flex: {
            'pt-0': true,
            'xs12': true,
            'd-grid': true,
        },
        props: {
            checkable: true,
            headers,
            noDataText: 'Sin permisos.',
            pickerProps: {
                filters: [],
                headers,
                noDataText: 'Sin permisos.',
                noPagination: false,
                paramFilter: {
                    role_hasnt_permission: props.role_id,
                },
                paramSearch: 'name',
                submitText: 'confirmar selección',
                service: PermissionModel,
            },
            showPicker: true,
            toolbarTitle: 'Lista de permisos asignados al rol',
        },
        trigger: props.selected_permissions_trigger,
    },
]